import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import { type IReferencePath } from '../../../../expressions/references/IReferencePath.ts';
import { type IAsyncValueWidget } from './IAsyncValueWidget.ts';

export function getAsyncValueWidgetReference(
  path: IReferencePath,
  widget: IAsyncValueWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      // Il valore è sempre una stringa, come per le async select
      type: Datatype.String,
    },
  };
}
